module.exports = __webpack_public_path__ + "2fbf04bd8738cdecb7a03bec53d1baf9.png";